import { AgGridReact } from 'ag-grid-react';
import React, {
    useCallback,
    useMemo,
    useRef,
    useState,
    StrictMode,
    useEffect
  } from "react";
  import { createRoot } from "react-dom/client";
  // import { ProgressSpinner } from 'primereact/progressspinner';
  import { Progressspinnerimg } from './loaderComp';


export const Tablescom = ({rowdata,coldefs,isloaded = false,quickFilterText='',pageSize,currentPage,totalRows=0,handlePrevious,handleNext,handlePageSizeChange,getRowClass,gridref,refreshGridcell= false,onRowClicked}) =>{
// export const Tablescom = ({rowdata,coldefs,isloaded = false,quickFilterText='',getRowClass,gridref}) =>{

    const defaultColDef = useMemo(() => ({
        filter: true,
       
        // editable: true,
      }));
      return (
          <div style={{ height: '100%',width: '100%' }}>
            <AgGridReact
                enableCellTextSelection={true}
                suppressClipboardPaste={true} 
                ref={gridref}
                rowData={rowdata}
                columnDefs={coldefs}
                domLayout="autoHeight"
                rowHeight={60}
                defaultColDef={defaultColDef}
                loading={isloaded}
                quickFilterText={quickFilterText}
                pagination={false} // ✅ IMPORTANT: disable internal pagination
                getRowClass={getRowClass}
                uppressExcelExport={true}
                onGridReady={(params) => {
                  params.api.sizeColumnsToFit();
                  if(refreshGridcell == 'refreshcell'){
                       params.api.refreshCells({ force: true });
                  }
                  
                }}
                onRowClicked={onRowClicked}
            />
{/* 🔄 Pagination & Info Container */}
<div style={{
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '10px',
  padding: '10px 15px',
  borderTop: '1px solid #ddd',
  fontSize: '14px',
}}>

  {/* 🔢 Page Size Selector */}
  <div>
    <label>
      Show&nbsp;
      <select
        onChange={handlePageSizeChange}
        value={pageSize}
        style={{
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          marginRight: '5px'
        }}
      >
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
      </select>
      entries per page
    </label>
  </div>

  {/* ⬅️➡️ Pagination Controls */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <button
      onClick={handlePrevious}
      disabled={currentPage === 1}
      style={{
        padding: '5px 10px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        backgroundColor: '#f8f9fa',
        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
        opacity: currentPage === 1 ? 0.5 : 1,
      }}
    >
      ⬅ Previous
    </button>

    <span>
      Page <strong>{currentPage}</strong> of <strong>{Math.ceil(totalRows / pageSize)}</strong>
    </span>

    <button
      onClick={handleNext}
      disabled={currentPage >= Math.ceil(totalRows / pageSize)}
      style={{
        padding: '5px 10px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        backgroundColor: '#f8f9fa',
        cursor: currentPage >= Math.ceil(totalRows / pageSize) ? 'not-allowed' : 'pointer',
        opacity: currentPage >= Math.ceil(totalRows / pageSize) ? 0.5 : 1,
      }}
    >
      Next ➡
    </button>
  </div>

  {/* 📦 Total Items Summary */}
  <div style={{ textAlign: 'right' }}>
    Showing&nbsp;
    <strong>{(currentPage - 1) * pageSize + 1}</strong>
    –
    <strong>{Math.min(currentPage * pageSize, totalRows)}</strong>
    &nbsp;of&nbsp;
    <strong>{totalRows}</strong> items
  </div>
</div>


            </div>
          );     
}
